<div class="row">
    <div class="col-sm-4">
      <h3 class="sub-title">List of Users</h3></div>
    <div class="col-sm-8 text-end">
      <a [routerLink]="['/user/guardian/create']" class="btn btn-primary" > <i class="fa fa-plus"> </i> Add New Guardian User </a>

    </div>
  </div>
  <app-user-list-fragment [users]="users" *ngIf="!isLoading"></app-user-list-fragment>
  <app-spinner *ngIf="isLoading"> </app-spinner>



